import React, { useMemo } from "react";
import { NativeSyntheticEvent, TextInput, TextInputChangeEventData } from "react-native";

import { InputProps } from "./Input.types";
import { useClassNames, useTheme } from "../../../structure";

export const Input = React.forwardRef((props: InputProps, ref: React.ForwardedRef<TextInput>) => {
  const { classNames, disabled, onChangeText } = props;
  const { colors } = useTheme().theme;

  const _classNames = useMemo(() => {
    const _classNames = classNames?.length ? classNames : ["input", "inputLarge"];
    if (disabled) {
      _classNames.push("inputDisabled");
    }

    return _classNames;
  }, [classNames, disabled]);

  const style = useClassNames(_classNames);
  const propsForwards = { ...props };
  delete propsForwards.classNames;
  const [isFocused, setIsFocused] = React.useState(false);

  const handleChangeText = (e: NativeSyntheticEvent<TextInputChangeEventData>) => {
    onChangeText && onChangeText(String(e.currentTarget.valueOf()));
  };
  return (
    <TextInput
      {...propsForwards}
      ref={ref}
      onChange={handleChangeText}
      onFocus={() => {
        setIsFocused(true);
        return propsForwards.onFocus;
      }}
      onBlur={() => {
        setIsFocused(false);
        return propsForwards.onBlur;
      }}
      placeholderTextColor={colors.neutralLighter.dark}
      style={
        {
          all: "unset",
          ...style,
          boxSizing: "border-box",
          borderColor: isFocused ? colors.info.main : style.borderColor,
        } as any
      }
    />
  );
});
